import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  User,
  TypeCedula,
  RolePermission,
  TypesInsurances,
  Module,
} from './user.model';
import { Role } from './user.model';
import { AuthService } from '../../shared/services/auth.service';

@Injectable()
export class UsersService {
  public urlBase = '/api/';
  constructor(public http: HttpClient) {}

  getUsers(): Observable<User[]> {
    return this.http.get<User[]>(this.urlBase + 'getUsers');
  }

  getAllUsers(id: number = 0): Observable<User[]> {
    return this.http.get<User[]>(this.urlBase + 'getAllUsers?userId=' + id);
  }

  getAllUsersChatStudent(id: number = 0): Observable<User[]> {
    return this.http.get<User[]>(
      this.urlBase + 'getAllUsersChatStudent?userId=' + id
    );
  }

  getByEmail(username: string, email: string): Observable<User> {
    return this.http.get<User>(
      this.urlBase + 'getUserByEmail?username=' + username + '&email=' + email
    );
  }

  verifyRecoverCode(code: string): Observable<any> {
    return this.http.get<any>(this.urlBase + 'verifyRecoverCode?code=' + code);
  }

  /* sendEmailRecoverPassword(data: any): Observable<any> {
        return this.http.post<any>('/mail/sendPortal', data);
    }*/

  sendEmailRecoverPassword(data: any): Observable<any> {
    return this.http.post(this.urlBase + 'sendPortal', data);
  }

  updateOrCreate(user: any) {
    return this.http.post(this.urlBase + 'saveUser', user);
  }

  saveProfile(user: User) {
    return this.http.post(this.urlBase + 'saveProfile', user);
  }

  savePhoto() {
    return this.http.post(this.urlBase + 'savePhoto', {
      userId: AuthService.getUser().id,
      photo: AuthService.getUser().photo,
    });
  }

  deleteUser(id: number) {
    return this.http.post(this.urlBase + 'deleteUser', { id: id });
  }

  activateUser(data) {
    return this.http.post(this.urlBase + 'activateUser', data);
  }

  getRoles(): Observable<Role[]> {
    return this.http.get<Role[]>(this.urlBase + 'getRoles');
  }

  getRolePermissions(): Observable<RolePermission> {
    return this.http.get<RolePermission>(
      this.urlBase +
        'getRolePermissions?roleId=' +
        AuthService.getUser().role.id
    );
  }

  getTypeCedulas(): Observable<TypeCedula[]> {
    return this.http.get<TypeCedula[]>(this.urlBase + 'getTypeCedulas');
  }

  getTypesInsurances(): Observable<TypesInsurances[]> {
    return this.http.get<TypesInsurances[]>(
      this.urlBase + 'getTypesInsurances'
    );
  }

  getTypeCedulasOfUser(id): Observable<TypeCedula[]> {
    return this.http.get<TypeCedula[]>(
      this.urlBase + 'getTypeCedulasOfUser?cedulaId=' + id
    );
  }

  userExist(username): Observable<boolean> {
    return this.http.get<boolean>(
      this.urlBase + 'userExist?username=' + username
    );
  }

  getModules(): Observable<Module[]> {
    return this.http.get<Module[]>(this.urlBase + 'getModules');
  }

  getModulesUser(userId = 0): Observable<Array<number>> {
    return this.http.get<Array<number>>(
      this.urlBase + 'getModulesUser?userId=' + userId
    );
  }

  getModulesEdit(userId = 0): Observable<Array<number>> {
    return this.http.get<Array<number>>(
      this.urlBase + 'getModulesEdit?userId=' + userId
    );
  }

  getModulesDelete(userId = 0): Observable<Array<number>> {
    return this.http.get<Array<number>>(
      this.urlBase + 'getModulesDelete?userId=' + userId
    );
  }

  /**
   * Obtiene módulos con permisos por rol: Update, Upload, Reject y Verify
   * @param userId Identificador del user
   * @returns array de permisos
  */
  getAdditionalModulesPermission(userId: number): Observable<{
      success: boolean;
      message: string;
      data?: { [key: string]: number[] };
  }> {
    const params = new HttpParams().set('userId', userId.toString());
    return this.http.get<any>( this.urlBase + 'getAdditionalModulesUser', { params })
  }

  setLastLogin(id: number): Observable<string> {
    return this.http.post<string>(this.urlBase + 'setLastLogin', { id });
  }
}
